import { lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { LandingNav } from "@/components/landing/LandingNav";
import { HeroSection } from "@/components/landing/HeroSection";
import { ApproachSection } from "@/components/landing/ApproachSection";
import { ServicesSection } from "@/components/landing/ServicesSection";
import { SEOHead } from "@/components/seo/SEOHead";
import { SchemaOrg } from "@/components/seo/SchemaOrg";

// Below-the-fold sections are loaded on demand to keep the initial bundle small
const InternationalSection = lazy(() =>
  import("@/components/landing/InternationalSection").then((m) => ({ default: m.InternationalSection }))
);
const TargetSection = lazy(() =>
  import("@/components/landing/TargetSection").then((m) => ({ default: m.TargetSection }))
);
const FAQSection = lazy(() =>
  import("@/components/landing/FAQSection").then((m) => ({ default: m.FAQSection }))
);
const ContactFormSection = lazy(() =>
  import("@/components/landing/ContactFormSection").then((m) => ({ default: m.ContactFormSection }))
);
const CTASection = lazy(() =>
  import("@/components/landing/CTASection").then((m) => ({ default: m.CTASection }))
);
const Footer = lazy(() =>
  import("@/components/landing/Footer").then((m) => ({ default: m.Footer }))
);
const CookieConsent = lazy(() =>
  import("@/components/CookieConsent").then((m) => ({ default: m.CookieConsent }))
);

export default function LandingPage() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/auth");
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOHead />
      <SchemaOrg type="organization" />
      <SchemaOrg type="localBusiness" />
      <SchemaOrg type="faq" />
      <SchemaOrg type="service" />
      
      <LandingNav />
      
      <main>
        <HeroSection />
        
        <div id="ansatz">
          <ApproachSection />
        </div>
        
        <ServicesSection />
        
        <Suspense fallback={<div className="min-h-[40vh]" />}>
          <div id="international">
            <InternationalSection />
          </div>
          
          <TargetSection />
          
          <div id="faq">
            <FAQSection />
          </div>
          
          <ContactFormSection />
          
          <CTASection />
        </Suspense>
      </main>
      
      <Suspense fallback={null}>
        <Footer onLogin={handleLogin} />
        <CookieConsent />
      </Suspense>
    </div>
  );
}
